import React from "react";
import classNames from "classnames";
import "./MobileNavLinks.scss";
import { NavLink, useLocation } from "react-router-dom";

export const MOBILE_NAV_ID = "mobile-navigation";

const MobileNavLinks = ({ open, onClose, onKeyDown, onBlur, navRef }) => {
  const location = useLocation();
  const displayMobileNavLinks = classNames("mobile-nav-wrapper", {
    open: open,
  });

  //Closing the menu hides the link that was activated. The new page moves focus itself,
  //so focus only goes back to the menu button when the page stays the same.
  const onLinkClick = (to) => () => {
    onClose(to === undefined || location.pathname === to);
  };

  //The anchor keeps the menu's position just below the header, since its absolute
  //position would otherwise be placed at the top of the app's flex column.
  return (
    <div className="mobile-nav-anchor">
      <nav
        id={MOBILE_NAV_ID}
        ref={navRef}
        aria-label="mobile navigation"
        className={displayMobileNavLinks}
        onKeyDown={onKeyDown}
        onBlur={onBlur}
      >
        <NavLink className="mobile-link lessons" to="/lessons" onClick={onLinkClick("/lessons")}>
          Lessons
        </NavLink>
        <a
          className="mobile-link user_guide"
          href="https://tech.aph.org/ttweb/"
          target="_blank"
          rel="noreferrer"
          onClick={onLinkClick()}
        >
          User Guide
        </a>
        <NavLink className="mobile-link about" to="/about" onClick={onLinkClick("/about")}>
          About
        </NavLink>
      </nav>
    </div>
  );
};

export default MobileNavLinks;
